import { regex } from "../../../common/constant"
import React from 'react';

export const statusDropdown = [
    { label: 'Approved', value: 'Approved' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Auto Rejected', value: 'Auto-Rejected' },
    { label: 'Approval Pending', value: 'Pending' },
]

export const searchInputOptions = [
    {
        label: 'PSID',
        keyName: 'psid',
        placeholder: 'Search by PSID',
        errorMsg: 'Please Enter 11 digit PSID',
        regex: regex.numeric,
        isValidInput: val => val?.length === 11,
    },
    {
        label: 'Application ID',
        keyName: 'applicationId',
        placeholder: 'Search by Application ID',
        errorMsg: 'Please Enter 8 digit application ID',
        regex: regex.numeric,
        isValidInput: val => val?.length === 8,
    }
]

export const statusStyles = {
    "Pending" : {bgColor : "#FFEDC8", textColor : "#705010" , text : "Approval Pending"},
    "Approved" : {bgColor : "#BBE2CE", textColor : "#0B442D" , text : "Approved"},
    "Rejected" : {bgColor : "#F9D9D7", textColor : "#B32306" , text : "Rejected"},
    "Auto-Rejected" : {bgColor : "#F9D9D7", textColor : "#B32306", text : "Auto Rejected"},
}

export const RemarkTooltipTitle = ({ remark, updatedOn }) => {
    return (
        <div style={{backgroundColor : "#FFFFFF"}} className="d-flex flex-column p-1">
            <div><b>Remark</b></div>
            <div>{remark || "-"}</div>
            <div style={{color : "#A9A9A9"}}>On {updatedOn}</div>
        </div>
    )
}

export const labelStyles = {
    margin: '4px',
    color: '#525f7f',
    fontWeight: 600,
    fontSize: '0.875rem'
}